// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressRecord__text-b7716b {
  margin: auto;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.ProgressRecord__record-ba0235 {
  margin-inline-end: 8px;
  display: block;
  width: 8px;
  height: 8px;
  background-color: var(--danger-40);
  border-radius: 50%;
}

.ProgressRecord__timer-f9dcc5 {
  margin-inline-end: 16px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.ProgressRecord__icon-stop-c7be73 {
  margin-inline-start: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/RecordingSection/ProgressRecord/ProgressRecord.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".text {\n  margin: auto;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.record {\n  margin-inline-end: 8px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  background-color: var(--danger-40);\n  border-radius: 50%;\n}\n\n.timer {\n  margin-inline-end: 16px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.icon-stop {\n  margin-inline-start: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `ProgressRecord__text-b7716b`,
	"record": `ProgressRecord__record-ba0235`,
	"timer": `ProgressRecord__timer-f9dcc5`,
	"icon-stop": `ProgressRecord__icon-stop-c7be73`,
	"iconStop": `ProgressRecord__icon-stop-c7be73`
};
module.exports = ___CSS_LOADER_EXPORT___;
